<template>
  <div>
    <ErrorPage v-if="role == 0" />
    <!-- MetaMask not connected prompt -->
    <div v-else-if="!isMetaMaskConnected" class="metamask-not-connected">
      <div class="title">MetaMask Not Connected</div>
      <div class="metamask-message">
        <!-- <h3>MetaMask Not Connected</h3> -->
        <p>Please connect your MetaMask wallet to check your airdrop eligibility.</p>
      </div>
      <div class="metamask-prompt">
        <!-- <div class="metamask-icon">
          <img src="../assets/images/user.png" alt="MetaMask" />
        </div> -->
        <el-button class="connect-btn" :loading="connectingMetaMask" @click="handleConnectMetaMask">
          Connect MetaMask
        </el-button>
      </div>
    </div>
    <div v-else-if="!chainSupported" class="ineligible-container">
      <div class="title">Wrong Network</div>
      <div class="ineligible-wallet">
        <div class="ineligible-title">Unsupported Network</div>
        <div class="ineligible-text">Please switch MetaMask to the correct TreasureNet network to continue.</div>
        <el-button class="switch-btn" @click="$emit('switch-network')">Switch Network</el-button>
      </div>
    </div>
    <div v-else-if="isRuntimeLoading" class="ineligible-container">
      <div class="title">Checking Airdrop Eligibility</div>
      <div class="ineligible-wallet">
        <div class="ineligible-title">Loading Wallet State</div>
        <div class="ineligible-text">Please wait while we verify your eligibility and claim status.</div>
      </div>
    </div>
    <div v-else-if="hasRecords === false" class="ineligible-container">
      <div class="title">Check for UNIT Airdrop Eligibility</div>
      <div class="ineligible-wallet">
        <div class="ineligible-title">Ineligible Wallet</div>
        <div class="ineligible-text">This wallet is not eligible for the Airdrop.</div>
        <el-button class="switch-btn" @click="handleSwitchAccount">Switch Account to Check Airdrop Eligibility</el-button>
      </div>
    </div>
    <div v-else-if="hasRecords && !hasAgreed">
      <div class="title">Please Review and Accept the Airdrop Terms</div>
      <div class="agreement-container">
        <div class="agreement-intro">
          <p>To proceed with claiming your airdrop, you must carefully review and accept the following terms and
            conditions.</p>
          <p>By accepting, you acknowledge that you have read, understood, and agreed to the terms outlined below.</p>
        </div>
        <!-- <div class="agreement-text">
          <div class="agreement-content">
            <p>TOKEN AIRDROP TERMS AND CONDITIONS (the "Agreement") is a binding contract between [NAME OF HKCO], a company incorporated under the laws of Hong Kong with offices located at [ADDRESS] ("HKCo") and you, a platform user ("You"). HKCo and You (each a "Party", collectively, the "Parties").</p>
            <p>This Agreement provides for: (a) the terms and conditions that govern your receipt of the [DESCRIBE THE TOKENS] (the "Tokens") in an airdrop of the Tokens conducted by HKCo; and (b) defines your rights and obligations. You acknowledge that: (a) the Tokens are intended for use on the blockchain application known as [DESCRIBE THE NETWORK] (the "Network"), which is governed by [DESCRIBE THE GOVERNANCE STRUCTURE OF THE NETWORK]; and (c) the fact that HKCo is undertaking a private airdrop of Tokens, which is not advertised to or made available to a limited number of persons or entities who are selected prior to the airdrop by way of the specific criteria determined at the sole discretion of HKCo, and not the Network and the governance of the Network and run and owned entirely by their respective founders.</p>
            <p>THIS AGREEMENT TAKES EFFECT WHEN YOU CLICK THE "ACCEPT THE TERMS AND CONDITIONS OF THIS AIRDROP" BUTTON (and the date of that acceptance being the "Effective Date").</p>
            <p>TO CLAIM YOUR AIRDROP TOKENS, YOU MUST CLICK THE "ACCEPT THE TERMS AND CONDITIONS OF THIS AIRDROP" BUTTON. PLEASE ALSO COPY AND PASTE THE CRYPTO WALLET ADDRESS WHERE APPLICABLE FOR YOUR USER WALLET (AS DEFINED BELOW).</p>
            <p>BY CLICKING ON THE "ACCEPT THE TERMS AND CONDITIONS OF THIS AIRDROP" BUTTON BELOW YOU: (A) ACKNOWLEDGE THAT YOU HAVE READ AND UNDERSTAND THIS AGREEMENT; (B) REPRESENT AND WARRANT THAT YOU HAVE THE RIGHT, POWER, AND AUTHORITY TO ENTER INTO THIS AGREEMENT; AND, IF ENTERING INTO THIS AGREEMENT ON BEHALF OF AN ORGANIZATION, THAT YOU HAVE THE LEGAL AUTHORITY TO BIND THAT ORGANIZATION; AND (C) ACCEPT THIS AGREEMENT AND AGREE THAT YOU ARE LEGALLY BOUND BY ITS TERMS.</p>
          </div>
        </div> -->
        <div class="agreement-checkbox">
          <el-checkbox v-model="termsAccepted">I ACCEPT THE TERMS AND CONDITIONS OF THIS AIRDROP
            <a href="#" class="terms-link" @click.prevent="openTermsModal">TOKEN AIRDROP TERMS AND
              CONDITIONS</a></el-checkbox>
          <div v-if="showCheckboxError" class="error-text">Please accept the terms and conditions to continue.</div>
        </div>
        <el-button
          class="accept-btn"
          :disabled="!termsAccepted"
          :loading="agreementLoading"
          @click="handleAcceptTerms"
        >Accept and Continue</el-button>
      </div>
    </div>
    <div v-else-if="hasRecords && hasAgreed && shouldShowClaimView" style="display: flex;flex-direction: column;align-items: center;">
      <div class="title">Claim Airdrop</div>
      <div class="des">Please claim your airdrop</div>

      <div class="con">
        <p class="user">
          <img src="../assets/images/user.png" alt="">
          <account :value="currentAccount" />
        </p>

        <div v-if="!hasManualClaim && hasAutoClaim">
          <div class="title-card">
            Auto Airdrop Amount:
            <soan style="font-size: 0.28rem;">
              <BigNumber :number="autoAmount" /> UNIT
            </soan>
          </div>

          <div class="auto-airdrop-info">
            <p>Airdrop tokens will be sent directly to your wallet in the future.</p>
            <p>Please check your wallet balance.</p>
          </div>
          <!-- <div class="auto-amount">
            <img src="../assets/images/icon.png" alt="" />
            <div class="num">
              <big-number :number="autoAmount" /><span>UNIT</span>
              <p>Will be airdropped</p>
            </div>
          </div> -->
        </div>

        <div v-if="hasManualClaim || (!hasAutoClaim && !hasManualClaim)" class="con_box">
          <div style="display: flex;align-items: center;">
            <img src="../assets/images/icon.png" alt="">
            <div class="num">
              <big-number :number="amount" /><span style="margin-left: 0.1rem;">UNIT</span>
              <p>Claimable</p>
            </div>
          </div>
          <div style="display: flex;align-items: center;">
            <div v-if="flag" class="success">
              <img src="../assets/images/success.png" alt="">
            </div>
            <el-button
              v-if="!flag && hasManualClaim"
              class="btn"
              :loading="btnLoading"
              :disabled="amount <= 0"
              @click="handleClaim()"
            >claim</el-button>
          </div>
        </div>
        <div v-if="hasAutoClaim && hasManualClaim" style="margin-top: 20px;text-align: left;" class="auto-airdrop-info">

          <!-- <div>You still have a portion of your airdrop tokens:
            <BigNumber :number="autoAmount" /> UNIT,
          </div>
          <div>which will be automatically sent to your wallet.</div>
          <div>Please keep an eye out for it.</div> -->
          <div class="title-card">
            Auto Airdrop Amount:
            <soan style="font-size: 0.28rem;">
              <BigNumber :number="autoAmount" /> UNIT
            </soan>
          </div>

          <div class="auto-airdrop-info">
            <p>Airdrop tokens will be sent directly to your wallet in the future.</p>
            <p>Please check your wallet balance.</p>
          </div>

        </div>

      </div>

      <!-- <div v-if="!hasManualClaim && !hasAutoClaim">

      </div> -->
      <!-- <div class="rules">
        <p class="bt">Airdrop Rules:</p>
        <p>
          The total amount of AirDrop is 9000W, 3000W is for the foundation, and 6000W is
          for airdrop.
        </p>
        <p>· The 6000W airdrop will be distributed within 12 months.</p>
        <p>· You will claim the specified amount airdrop every month.</p>
        <p>
          · If you have not claimed the UNIT that should be claimed in the current
          <br />&nbsp;&nbsp;month, you can claim it in the next month.
        </p>
        <p>
          If you have any questions, please email us at <b>contact@treasurenet.org</b>.
        </p>
      </div> -->
    </div>
    <div v-else-if="hasRecords && hasAgreed" class="ineligible-container">
      <div class="title">Airdrop Claimed</div>
      <div class="ineligible-wallet">
        <div class="ineligible-title">No Claimable Balance</div>
        <div class="ineligible-text">This wallet currently has no claimable airdrop balance.</div>
      </div>
    </div>
    <div v-else class="ineligible-container">
      <div class="title">Unable to Load Airdrop State</div>
      <div class="ineligible-wallet">
        <div class="ineligible-title">Wallet State Unavailable</div>
        <div class="ineligible-text">We could not verify your eligibility right now. Please refresh and try again.</div>
      </div>
    </div>

    <!-- Terms details modal -->
    <el-dialog
      title="TOKEN AIRDROP TERMS AND CONDITIONS"
      :visible.sync="termsModalVisible"
      width="70%"
      :close-on-click-modal="false"
      class="terms-dialog"
    >
      <div class="terms-content">
        <p>THESE TOKEN AIRDROP TERMS AND CONDITIONS (the "Agreement") is a binding contract between [NAME OF HKCO], a
          company incorporated under the laws of Hong Kong with offices located at [ADDRESS] ("HKCo") and you the
          platform user ("You"), HKCo and You (each a "Party", collectively, the "Parties").</p>
        <p>This Agreement provides for: (a) the terms and conditions that govern your receipt of the [DESCRIBE THE
          TOKENS] (the "Tokens") in an airdrop of the Tokens conducted by HKCo, and it defines your rights and
          obligations with respect to the Tokens; (b) the fact that HKCo created and minted the Tokens, which are a
          native digital asset intended to interact with and enable use of the blockchain application known as [DESCRIBE
          THE NETWORK] (the "Network"), which is governed by [DESCRIBE THE GOVERNANCE STRUCTURE OF THE NETWORK]; and (c)
          the fact that HKCo is undertaking a private airdrop of Tokens, which is not advertised and is made available
          to a limited number of persons or entities who are selected prior to the airdrop by way of this Agreement and
          where the recipients of such airdrop desire to participate in the Network and in the governance of the Network
          and run consensus nodes and staking, which requires that such recipients have Tokens.</p>
        <p>This Agreement incorporates the attached Exhibit A – General Terms and Conditions.</p>
        <p>THIS AGREEMENT TAKES EFFECT WHEN YOU CLICK THE "I ACCEPT THE TERMS AND CONDITIONS OF THIS AIRDROP" BUTTON
          (and the date of that acceptance being the "Effective Date").</p>
        <p>IF YOU CLICK ON THE "I ACCEPT THE TERMS AND CONDITIONS OF THIS AIRDROP" BUTTON, PLEASE ALSO COPY AND PASTE
          THE CRYPTO WALLET ADDRESS WHERE APPLICABLE FOR YOUR USER WALLET (AS DEFINED BELOW).</p>
        <p>BY CLICKING ON THE "I ACCEPT THE TERMS AND CONDITIONS OF THIS AIRDROP" BUTTON BELOW YOU: (A) ACKNOWLEDGE THAT
          YOU HAVE READ AND UNDERSTAND THIS AGREEMENT; (B) REPRESENT AND WARRANT THAT YOU HAVE THE RIGHT, POWER, AND
          AUTHORITY TO ENTER INTO THIS AGREEMENT AND, IF ENTERING INTO THIS AGREEMENT FOR AN ORGANIZATION, THAT YOU HAVE
          THE LEGAL AUTHORITY TO BIND THAT ORGANIZATION; AND (C) ACCEPT THIS AGREEMENT AND AGREE THAT YOU ARE LEGALLY
          BOUND BY ITS TERMS.</p>

        <p><strong>A. I ACCEPT THE TERMS AND CONDITIONS OF THIS AIRDROP ☐</strong></p>

        <p><strong>B. YOU HEREBY IRREVOCABLY DIRECT HKCO TO PROCURE THE TRANSFER OF ALL OF THE TOKENS TO BE AIRDROPPED
          TO YOU UNDER THIS AGREEMENT TO THE USER WALLET (AS DEFINED BELOW).</strong></p>

        <p><strong>C. YOUR CRYPTO WALLET ADDRESS (the "User Wallet"), which will be the crypto wallet that HKCo has
          already been provided with.</strong></p>

        <h3>Exhibit A</h3>
        <h4>General Terms and Conditions</h4>

        <ol>
          <li><strong>Interpretation.</strong> No provision of this Agreement will be construed against either Party by
            virtue of that Party having drafted and prepared this Agreement. All headings are inserted for reference
            only. The term "including" is not limiting, and means "including without limitation". The singular includes
            the plural and vice-versa, unless the context otherwise requires.</li>
          <li><strong>No Claim or Ownership Interest.</strong> Except as otherwise expressly set forth herein, the Your
            ownership of Tokens: (a) does not provide You with rights of any form with respect to HKCo or its revenues
            or assets, including, without limitation, any voting, distribution, redemption, liquidation, proprietary
            (including all forms of intellectual property) or other financial or legal rights; and (b) does not provide
            You with any ownership, equity, or other interest in HKCo; provided, however, that You shall be entitled to
            use the Tokens to participate in the governance of the Network on the same basis as Token holders generally.
          </li>
          <li><strong>Intellectual Property.</strong> You acknowledge and agree that HKCo retains all right, title and
            interest in all of HKCo's intellectual property contained in the Tokens, including, without limitation,
            inventions, ideas, concepts, code, discoveries, processes, marks, methods, software, compositions, formulae,
            techniques, information and data, whether or not patentable, copyrightable or protectable in trademark, and
            any trademarks, copyright or patents based thereon. You agree not to use, reverse engineer, modify, or alter
            any of HKCo's intellectual property for any reason without HKCo's prior written consent.</li>
          <li><strong>Your Representations and Warranties.</strong> In connection with the airdrop of Tokens to You, You
            hereby represent and warrant to HKCo that on the Effective Date:
            <ol type="a">
              <li>You have all requisite power and authority to execute and deliver this Agreement, to accept the
                airdrop of the Tokens, and to carry out and perform Your obligations under this Agreement. All action on
                Your part required for the lawful execution and delivery of this Agreement and other agreements required
                hereunder have been or will be effectively taken prior to the Effective Date. This Agreement has been
                duly executed by You. This Agreement constitutes a legal, valid and binding obligation of Yours
                enforceable against You in accordance with its terms, except that such enforceability may be limited by
                applicable bankruptcy, insolvency, reorganization, moratorium and similar laws of general application
                relating to or affecting creditors' rights generally and by equitable principles (regardless of whether
                enforcement is sought in a proceeding in equity or at law).</li>
              <li>HKCo's dealings with You and others who may receive Tokens from HKCo need not be uniform, and, without
                limiting the foregoing, HKCo shall be entitled, among other things, to enter into agreements with such
                other recipients (and/or other persons) on terms different than those set forth herein.</li>
              <li>You are acquiring the Tokens with the primary intention to use the Tokens, and You represent and
                warrant that You have no current intent to resell the Tokens.</li>
              <li>You are fully aware of the risks associated with owning and using Tokens, including the inherent risk
                of the potential for Tokens, and/or the private keys to Tokens, to be lost, stolen, or hacked. By
                acquiring Tokens, You expressly acknowledge and assume these risks.</li>
              <li>You have sufficient understanding of technical matters relating to Tokens, the Network, digital asset
                storage mechanisms (such as digital asset wallets), and blockchain technology, to understand how to
                acquire, store, and use Tokens, and to appreciate the risks and implications of acquiring Tokens.</li>
              <li>You acknowledge that HKCo has made no representations or warranties whatsoever regarding the Tokens
                and their functionality, or the assets, business, financial condition or prospects of HKCo or the
                Network.</li>
              <li>You acknowledge that HKCo has made no representations or warranties whatsoever regarding the income
                tax consequences regarding the receipt or ownership of the Tokens.</li>
              <li>The execution, delivery and performance of this Agreement will not result in: (i) any violation of, be
                in conflict with or constitute a material default under, with or without the passage of time or the
                giving of notice of: (A) any provision of Your organizational documents, if applicable; (B) any
                provision of any judgment, decree or order to which You are a party, by which You are bound, or to which
                any of Your assets are subject; (C) any agreement, obligation, duty or commitment to which You are a
                party or by which You are bound; or (D) any laws, statutes, ordinances, rules, regulations, judgments,
                injunctions, administrative interpretations, orders and decrees of any Governmental Authority, including
                amendments thereto (collectively, "Laws"); or (ii) the creation of any lien, charge or encumbrance upon
                any of Your assets. "Governmental Authority" shall mean any nation or government, any state or other
                political subdivision thereof, any entity exercising legislative, executive, judicial or administrative
                functions of or pertaining to government, including without limitation any government authority, agency,
                department, board, commission or instrumentality and any court, tribunal or arbitrator(s) of competent
                jurisdiction and any self-regulatory organization. For the avoidance of doubt, Governmental Authority
                may include private bodies exercising quasi-governmental, regulatory or judicial-like functions to the
                extent they relate to either Parties or the Tokens.</li>
              <li>You represent and warrant that HKCo has not advertised the airdrop of the Tokens to You.</li>
            </ol>
            The foregoing shall be continuing representations, warranties, and covenants given by You throughout the
            Term of this Agreement and shall apply to You, as at and after the Effective Date of this Agreement.
          </li>
          <li><strong>Term.</strong> Subject to Section 6 below, the initial term (the "Initial Term") of this Agreement
            will begin on the Effective Date and shall continue for a period of one (1) year, with automatic renewals
            for successive one (1) year periods unless HKCo provides written notice of non-renewal to You at least 30
            days prior to the end of the then current term. "Term" shall mean the Initial Term and any and all renewal
            terms.</li>
          <li><strong>Termination.</strong> Either Party may terminate this Agreement: (i) in the event of a material
            breach by a Party of this Agreement that is not cured within 10 days after written notice of such breach has
            been given to such Party by the other Party; (ii) immediately upon notice in the event of a material breach
            of any provision of this Agreement by the other Party that is not capable of being cured; or (iii)
            immediately upon notice, if either Party becomes insolvent or seeks protection under any bankruptcy,
            receivership, creditor's arrangement, or comparable proceeding.</li>
        </ol>
        <p>The full terms and conditions continue in the complete agreement document.</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="termsModalVisible = false">Close</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ErrorPage from './ErrorPage.vue'
import { getHasRecords, getUnclaimedTokens, getAgreement, createAgreement, getAbi } from '@/api/file'
import Web3 from 'web3'
import {
  ensureTargetChain,
  getActiveWalletAccount,
  requestWalletConnection,
  requestWalletPermissions,
  setStoredWalletAccount
} from '@/utils/walletRuntime'

export default {
  components: {
    ErrorPage
  },
  props: {
    account: {
      type: String,
      default: null
    },
    chainSupported: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      role: undefined,
      currentAccount: null,
      amount: 0,
      autoAmount: 0,
      hasAutoClaim: false,
      hasManualClaim: false,
      contractAirdrop: undefined,
      contractAirdropAddress: undefined,
      flag: false,
      btnLoading: false,
      web3: null,
      hasRecords: null,
      hasAgreed: false,
      claimStateResolved: false,
      termsAccepted: false,
      showCheckboxError: false,
      agreementLoading: false,
      termsModalVisible: false,
      isMetaMaskConnected: false,
      connectingMetaMask: false,
      isRuntimeLoading: false
    }
  },
  computed: {
    runtimeRefreshKey() {
      return `${this.account || ''}:${this.chainSupported}:${Boolean(this.web3)}`
    },
    shouldShowClaimView() {
      return !this.claimStateResolved || this.hasManualClaim || this.hasAutoClaim
    },
    hasClaimableView() {
      return this.hasManualClaim || this.hasAutoClaim
    }
  },
  watch: {
    runtimeRefreshKey: {
      immediate: true,
      handler() {
        this.currentAccount = this.account || null
        this.isMetaMaskConnected = Boolean(this.account)
        this.refreshRuntimeState()
      }
    }
  },
  created() {
    if (window.ethereum) {
      this.web3 = new Web3(window.ethereum)
    }
  },
  methods: {
    async refreshRuntimeState() {
      this.resetClaimState()

      if (!this.isMetaMaskConnected || !this.chainSupported || !this.web3) {
        this.isRuntimeLoading = false
        return
      }

      this.isRuntimeLoading = true

      try {
        await this.syncActiveAccount()
        await this.ensureContract()
        await this.fetchEligibilityState()

        if (this.hasRecords) {
          await this.fetchClaimBalances()
        }
      } catch (error) {
        this.$message.error(
          error && error.message ? error.message : 'Failed to initialize airdrop data'
        )
      } finally {
        this.isRuntimeLoading = false
      }
    },
    resetClaimState() {
      this.isRuntimeLoading = false
      this.hasRecords = null
      this.hasAgreed = false
      this.claimStateResolved = false
      this.hasAutoClaim = false
      this.hasManualClaim = false
      this.autoAmount = 0
      this.amount = 0
      this.flag = false
      this.termsAccepted = false
      this.showCheckboxError = false
    },
    async syncActiveAccount() {
      const account = await getActiveWalletAccount()

      if (account && account !== this.currentAccount) {
        this.currentAccount = account
        this.$emit('account-change', account)
      }
    },
    async ensureContract() {
      if (this.contractAirdrop && this.contractAirdropAddress) {
        return
      }

      const res = await getAbi('TokenLocker')
      this.contractAirdrop = new this.web3.eth.Contract(
        res.data.abi,
        res.data.address
      )
      this.contractAirdropAddress = res.data.address
    },
    async fetchEligibilityState() {
      const res = await getHasRecords(this.currentAccount)

      if (res.code === 0) {
        this.hasRecords = res.data.hasRecords
        await this.checkAgreementStatus()
        await this.fetchClaimBalances()
      } else {
        this.hasRecords = false
        this.$message.error(res.message)
      }
    },
    async checkAgreementStatus() {
      try {
        const res = await getAgreement(this.currentAccount)
        if (res.code === 0) {
          this.hasAgreed = res.data.hasAgreed
        } else {
          this.hasAgreed = false
          this.$message.error(res.message || 'Failed to get agreement status')
        }
      } catch (error) {
        this.hasAgreed = false
        this.$message.error('Failed to get agreement status')
      }
    },
    async handleAcceptTerms() {
      if (!this.termsAccepted) {
        this.showCheckboxError = true
        return
      }

      this.showCheckboxError = false
      this.agreementLoading = true

      try {
        const res = await createAgreement({
          userAddress: this.currentAccount,
          agreementType: 'tokenlocker'
        })

        if (res.code === 0) {
          this.hasAgreed = true
          this.$message.success('I ACCEPT THE TERMS AND CONDITIONS OF THIS AIRDROP')
        } else {
          this.$message.error(
            res.message || 'I ACCEPT THE TERMS AND CONDITIONS OF THIS AIRDROP'
          )
        }
      } catch (error) {
        this.$message.error('I ACCEPT THE TERMS AND CONDITIONS OF THIS AIRDROP')
      } finally {
        this.agreementLoading = false
      }
    },
    openTermsModal() {
      this.termsModalVisible = true
    },
    async handleSwitchAccount() {
      try {
        const account = await requestWalletPermissions()
        if (account) {
          this.currentAccount = account
          this.$emit('account-change', account)
          this.$message.success('Account switched successfully')
        }
      } catch (error) {
        this.$message.error('Account switch failed')
      }
    },
    async fetchClaimBalances() {
      try {
        const res = await getUnclaimedTokens(this.currentAccount)

        if (res.code === 0 && res.data) {
          this.claimStateResolved = true
          const claimMethods = res.data.claimMethods || []
          this.hasAutoClaim = false
          this.hasManualClaim = false
          this.autoAmount = 0
          this.amount = 0

          claimMethods.forEach(item => {
            if (item.claimMethod === 0) {
              this.hasAutoClaim = true
              this.autoAmount = this.web3.utils.toWei(item.amount.toString(), 'ether')
            } else if (item.claimMethod === 1) {
              this.hasManualClaim = true
              this.amount = this.web3.utils.toWei(item.amount.toString(), 'ether')
            }
          })
        } else {
          this.claimStateResolved = false
          this.hasAutoClaim = false
          this.hasManualClaim = false
          this.autoAmount = 0
          this.amount = 0
          this.$message.error(res.message || 'Failed to get data')
        }
      } catch (error) {
        this.claimStateResolved = false
        this.$message.error('Failed to get data')
      }
    },
    async settleClaimState() {
      const maxAttempts = 12
      const delayMs = 5000

      for (let attempt = 0; attempt < maxAttempts; attempt++) {
        await this.fetchClaimBalances()
        if (!this.hasManualClaim) {
          return
        }
        await new Promise(resolve => setTimeout(resolve, delayMs))
      }
    },
    async handleClaim() {
      this.btnLoading = true

      try {
        if (!window.ethereum) {
          this.$message.error('Please install MetaMask wallet')
          return
        }

        if (!this.chainSupported) {
          this.$emit('switch-network')
          return
        }

        let activeAccount = await getActiveWalletAccount()
        if (!activeAccount) {
          activeAccount = await requestWalletConnection()
        }

        if (!activeAccount) {
          this.$message.error('Please connect wallet account first')
          return
        }

        this.currentAccount = activeAccount
        setStoredWalletAccount(activeAccount)
        this.$emit('account-change', activeAccount)

        const txBuilder = this.contractAirdrop.methods.claimToken(this.currentAccount)
        const encodedTx = txBuilder.encodeABI()
        const estimatedGas = await txBuilder.estimateGas({ from: this.currentAccount })
        const gasLimit = Math.floor(estimatedGas * 1.2)
        const block = await this.web3.eth.getBlock('latest')
        const supportsEIP1559 = block && block.baseFeePerGas !== undefined

        let payload = {}

        if (supportsEIP1559) {
          const baseFeePerGas = block.baseFeePerGas
          const maxPriorityFeePerGas = this.web3.utils.toWei('2', 'gwei')
          const maxFeePerGas = this.web3.utils
            .toBN(baseFeePerGas)
            .mul(this.web3.utils.toBN(2))
            .add(this.web3.utils.toBN(maxPriorityFeePerGas))
            .toString()

          payload = {
            from: this.currentAccount,
            to: this.contractAirdropAddress,
            gas: gasLimit,
            maxFeePerGas,
            maxPriorityFeePerGas,
            value: 0,
            data: encodedTx,
            type: '0x2'
          }
        } else {
          const gasPrice = await this.web3.eth.getGasPrice()
          payload = {
            from: this.currentAccount,
            to: this.contractAirdropAddress,
            gas: gasLimit,
            gasPrice,
            value: 0,
            data: encodedTx,
            type: '0x0'
          }
        }

        await this.web3.eth.sendTransaction(payload)
        this.$message.success('Claim successful')
        this.flag = true
        await this.settleClaimState()
      } catch (error) {
        if (error.code === 4001) {
          this.$message.error('User cancelled the transaction')
        } else if (error.message && error.message.includes('User denied')) {
          this.$message.error('User rejected the transaction')
        } else if (error.message && error.message.includes('insufficient funds')) {
          this.$message.error('Insufficient account balance to pay Gas fees')
        } else {
          this.$message.error(error.message || 'Claim failed')
        }
      } finally {
        this.btnLoading = false
      }
    },
    async handleConnectMetaMask() {
      this.connectingMetaMask = true
      try {
        await ensureTargetChain()
        const account = await requestWalletConnection()

        if (account) {
          this.currentAccount = account
          this.isMetaMaskConnected = true
          this.$emit('account-change', account)
          this.$message.success('MetaMask connected successfully')
        }
      } catch (error) {
        if (error.code === 4001) {
          this.$message.error('User rejected the connection request')
        } else {
          this.$message.error('Failed to connect MetaMask')
        }
      } finally {
        this.connectingMetaMask = false
      }
    }
  }
}
</script>

<style scoped>
.title {
  font-size: 0.44rem;
  font-family: DMSans-Bold, DMSans;
  font-weight: bold;
  color: #1f1f1f;
  line-height: 0.58rem;
}

.des {
  font-size: 0.24rem;
  font-family: DMSans-Regular, DMSans;
  font-weight: 400;
  color: #4c4c4c;
  line-height: 0.32rem;
}

/* Agreement container styles */
.agreement-container {
  /* width: 90%;
  max-width: 800px; */
  margin: 0.4rem auto;
  background: #ffffff;
  border-radius: 0.2rem;
  border: 0.01px solid #e0e0e0;
  padding: 0.5rem;
  box-sizing: border-box;
}

.agreement-intro {
  font-size: 0.2rem;
  line-height: 1.5;
  color: #4c4c4c;
  margin-bottom: 0.8rem;
}

.agreement-text {
  max-height: 300px;
  overflow-y: auto;
  padding: 1rem;
  border: 1px solid #e0e0e0;
  border-radius: 0.1rem;
  background: #f9f9f9;
  margin-bottom: 1.5rem;
}

.agreement-content {
  font-size: 0.18rem;
  line-height: 1.6;
  color: #333;
}

.agreement-checkbox {
  margin-bottom: 0.5rem;
}

.terms-link {
  color: #225bfc;
  text-decoration: underline;
}

.accept-btn {
  width: 80%;
  height: 0.6rem;
  background: linear-gradient(90deg, #225bfc 0%, #1c50de 100%);
  border-radius: 0.1rem;
  font-size: 0.2rem;
  font-family: DMSans-Medium, DMSans;
  font-weight: 500;
  color: #ffffff;
  display: block;
  margin: 0 auto;
}

.accept-btn:disabled {
  background: #cccccc;
  color: #666666;
  cursor: not-allowed;
}

.error-text {
  color: #f56c6c;
  font-size: 0.16rem;
  margin-top: 0.2rem;
}

.terms-dialog .terms-content {
  font-size: 0.18rem;
  line-height: 1.6;
  color: #333;
  max-height: 400px;
  overflow-y: auto;
}

/* ------------ */
.con {
  /* width: 5.34rem; */
  /* height: 1.84rem; */
  background: #ffffff;
  border-radius: 0.2rem;
  border: 0.01px solid #e0e0e0;
  margin-top: 0.4rem;
  margin-bottom: 0.2rem;
  /* padding-top: 0.24rem;
  padding-left: 0.2rem; */
  box-sizing: border-box;
  padding: 0.4rem;
}

.con .user {
  width: 1.46rem;
  height: 0.28rem;
  background: #f4f6f6;
  border-radius: 0.13rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.16rem;
  font-family: DMSans-Medium, DMSans;
  font-weight: 500;
  color: #65646a;
  line-height: 0.28rem;
  margin-bottom: 0.2rem;
}

.con .user img {
  height: 0.16rem;
  margin-right: 0.08rem;
}

/* ---------- */
.con_box {
  /* width: 4.94rem;
  height: 0.88rem; */
  background: #ffffff;
  box-shadow: 0px 2px 8px 0px rgba(204, 204, 204, 0.5);
  border-radius: 0.12rem;
  margin-top: 0.2rem;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  padding: 0.2rem;
  padding-left: 0.4rem;
}

.con_box img {
  height: 0.44rem;
  /* margin-left: 0.16rem; */
  margin-right: 0.1rem;
}

.con_box .num {
  font-size: 0.32rem;
  font-family: DMSans-Bold, DMSans;
  font-weight: bold;
  color: #1f1f1f;
  margin-right: 0.85rem;
}

.con_box .num span {
  font-size: 0.22rem;
  font-family: DMSans-Bold, DMSans;
  font-weight: bold;
  color: #1f1f1f;
}

.con_box .num p {
  font-size: 0.16rem;
  font-family: DMSans-Regular, DMSans;
  font-weight: 400;
  color: #aaaaaa;
  line-height: 0.21rem;
}

.con_box .btn {
  /* width: 1.08rem; */
  /* height: 0.36rem; */
  background: linear-gradient(90deg, #225bfc 0%, #1c50de 100%);
  border-radius: 0.04rem;
  font-size: 0.16rem;
  font-family: DMSans-Medium, DMSans;
  font-weight: 500;
  color: #ffffff;
  cursor: pointer;
  text-align: center;
}

/* Auto airdrop styles */
.auto-airdrop-container {
  /* width: 5.34rem; */
  background: #ffffff;
  border-radius: 0.2rem;
  border: 0.01px solid #e0e0e0;
  margin-top: 0.4rem;
  margin-bottom: 0.4rem;
  padding: 0.4rem 0.3rem;
  box-sizing: border-box;
}

.title-card {
  font-size: 0.24rem;
  font-family: DMSans-Bold, DMSans;
  font-weight: bold;
  color: #1f1f1f;
  margin-bottom: 0.14rem;
}

.auto-airdrop-info {
  font-size: 0.18rem;
  font-family: DMSans-Regular, DMSans;
  font-weight: 400;
  color: #4c4c4c;
  line-height: 0.28rem;
  margin-bottom: 0.2rem;
}

.auto-amount {
  width: 4.94rem;
  height: 0.88rem;
  background: #ffffff;
  box-shadow: 0px 2px 8px 0px rgba(204, 204, 204, 0.5);
  border-radius: 0.12rem;
  display: flex;
  align-items: center;
  padding: 0 0.16rem;
  box-sizing: border-box;
}

.auto-amount img {
  height: 0.44rem;
  margin-right: 0.1rem;
}

.auto-amount .num {
  font-size: 0.32rem;
  font-family: DMSans-Bold, DMSans;
  font-weight: bold;
  color: #1f1f1f;
}

.auto-amount .num span {
  font-size: 0.22rem;
  font-family: DMSans-Bold, DMSans;
  font-weight: bold;
  color: #1f1f1f;
}

.auto-amount .num p {
  font-size: 0.16rem;
  font-family: DMSans-Regular, DMSans;
  font-weight: 400;
  color: #aaaaaa;
  line-height: 0.21rem;
}

/* ----------- */
.rules .bt {
  font-size: 0.2rem;
  font-family: DMSans-Bold, DMSans;
  font-weight: bold;
  color: #4c4c4c;
  line-height: 0.26rem;
}

.rules {
  width: 6.5rem;
  font-size: 0.18rem;
  font-family: DMSans-Regular, DMSans;
  font-weight: 400;
  color: #4c4c4c;
  line-height: 0.24rem;
}

/* Ineligible wallet styles */
.ineligible-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ineligible-wallet {
  width: 5.34rem;
  background: #ffffff;
  border-radius: 0.2rem;
  border: 0.01px solid #e0e0e0;
  margin-top: 1rem;
  padding: 0.5rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ineligible-title {
  font-size: 0.32rem;
  font-family: DMSans-Bold, DMSans;
  font-weight: bold;
  color: #1f1f1f;
  margin-bottom: 0.3rem;
}

.ineligible-text {
  font-size: 0.2rem;
  font-family: DMSans-Regular, DMSans;
  font-weight: 400;
  color: #4c4c4c;
  margin-bottom: 0.6rem;
}

.switch-btn {
  /* width: 3.5rem; */
  /* height: 0.5rem; */
  background: #E5FFF6;
  border: none;
  border-radius: 0.08rem;
  font-size: 0.18rem;
  font-family: DMSans-Medium, DMSans;
  font-weight: 500;
  color: #00C389;
  cursor: pointer;
}

/* MetaMask not connected styles */
.metamask-not-connected {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1rem;
}

.metamask-prompt {
  background: #ffffff;
  border-radius: 0.2rem;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.metamask-icon {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: #f4f6f6;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.5rem;
}

.metamask-message {
  text-align: center;
}

.metamask-message h3 {
  font-size: 0.32rem;
  font-family: DMSans-Bold, DMSans;
  font-weight: bold;
  color: #1f1f1f;
  margin-bottom: 0.2rem;
}

.metamask-message p {
  font-size: 0.18rem;
  font-family: DMSans-Regular, DMSans;
  font-weight: 400;
  color: #4c4c4c;
}

.connect-btn {
  background: linear-gradient(90deg, #225bfc 0%, #1c50de 100%);
  border: none;
  border-radius: 0.08rem;
  font-size: 0.18rem;
  font-family: DMSans-Medium, DMSans;
  font-weight: 500;
  color: #ffffff;
  cursor: pointer;
  padding: 0.2rem 0.4rem;
  /* margin-top: 0.3rem; */
}
</style>
